export const PageNames = {
  ROOT: 'ROOT',
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
  PROFILE: 'PROFILE',
};

export const pageNameToModuleMap = {
  [PageNames.SIGN_IN]: 'signIn',
  [PageNames.SIGN_UP]: 'signUp',
  [PageNames.PROFILE]: 'profile',
};
